import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

import grey from "@material-ui/core/colors/grey";
import Grid from "@material-ui/core/Grid";
import { map } from "ramda";
import { Box } from "@material-ui/core";
import { notBlank } from "../util/ext";

const useStyles = makeStyles(theme => ({
  itemContent: {
    height: "auto",
    fontSize: "1.4rem",
    borderBottom: "solid",
    borderBottomColor: grey[200],
  },

  listItemText: {
    textTransform: "none",
  },

  contentTitle: {
    fontSize: "1.8rem",
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
  },

  mainDetail: {
    fontSize: "1.4rem",
    display: "flex",
    justifyContent: "flex-start",

    "& label": {
      fontWeight: "bold",
      paddingRight: "0.5em",
    },
  },
}));

const RipEndpointListItem = ({ endpoint, selected, findModule }) => {
  const classes = useStyles();

  return (
    <ListItem
      selected={selected}
      classes={{ root: classes.itemContent }}
      key={endpoint.ripEndpointId}
    >
      <ListItemText
        classes={{ root: classes.listItemText }}
        disableTypography={true}
        primary={
          <React.Fragment>
            <div className={classes.contentTitle}>
              {endpoint.ripEndpointName}
            </div>
          </React.Fragment>
        }
        secondary={
          <React.Fragment>
            <Grid container justify="space-between" spacing={5}>
              <Grid item sm={6}>
                <div className={classes.mainDetail}>
                  <label>RIP Endpoint Id:</label>
                  {endpoint.ripEndpointId}
                </div>
              </Grid>

              <Grid item sm={6}>
                <div className={classes.mainDetail}>
                  <label>Upload Path:</label>
                  {endpoint.ripEndpoint}
                </div>
              </Grid>

              {notBlank(endpoint.defaultModules) && (
                <Grid item sm={6}>
                  <div className={classes.mainDetail}>
                    <label>Default Modules:</label>
                    <Box>
                      {map(
                        module => (
                          <Box>{findModule(module)}</Box>
                        ),
                        endpoint.defaultModules,
                      )}
                    </Box>
                  </div>
                </Grid>
              )}
            </Grid>
          </React.Fragment>
        }
      />
    </ListItem>
  );
};

export default RipEndpointListItem;
